export const listAnnouncementsByOrganization = /* GraphQL */`
  query ListAnnouncementsByOrganization($orgId: ID!, $filter: ModelAnnouncementFilterInput) {
    listAnnouncementsByOrganization(orgId: $orgId, filter: $filter) {
      items {
        id
        title
        text
        status
        createdAt
        updatedAt
      }
    }
  }
`;
